'use client';

import { cn } from '@repo/ui/lib/utils';
import type * as React from 'react';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-[var(--rule)]', className)}
      {...props}
    />
  );
}

export { Skeleton };
